import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import MovieDetail from "@/pages/movie/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import About from "@/pages/about/page";
import SearchPage from "@/pages/search/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category", element: <Category /> },
      { path: "movie/:id", element: <MovieDetail /> },
      { path: "news", element: <NewsList /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "about", element: <About /> },
      { path: "search", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;